import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "login" };
const _hoisted_2 = { class: "remember" };
const _hoisted_3 = {
    key: 0,
    class: "error"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[9] || (_cache[9] = _createElementVNode("img", {
            src: "/logo.png",
            alt: "Logo",
            class: "logo"
        }, null, -1)),
        _cache[10] || (_cache[10] = _createElementVNode("h1", null, "CLIENT PORTAL", -1)),
        _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
        }, [
            _createElementVNode("div", null, [
                _cache[4] || (_cache[4] = _createElementVNode("label", {
                    class: "email",
                    for: "email"
                }, "Username or Email Address:", -1)),
                _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.email) = $event)),
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.email]
                ])
            ]),
            _createElementVNode("div", null, [
                _cache[5] || (_cache[5] = _createElementVNode("label", {
                    class: "password",
                    for: "password"
                }, "Password:", -1)),
                _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.password) = $event)),
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.password]
                ])
            ]),
            _createElementVNode("div", _hoisted_2, [
                _withDirectives(_createElementVNode("input", {
                    id: "remember",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.rememberMe) = $event))
                }, null, 512), [
                    [_vModelCheckbox, _ctx.rememberMe]
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("label", { for: "remember" }, "Remember Me", -1))
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("button", {
                class: "button",
                type: "submit"
            }, "Log In", -1)),
            (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "lost-password" }, [
                _createElementVNode("a", { href: "/forgot-password" }, "Lost your password?")
            ], -1))
        ], 32)
    ]));
}
